import { reduce } from 'lodash';

//import { SEGMENT_TYPE } from 'itrvl-types'; // Does not work for Window calls?
//import { SEGMENT_TYPE } from './segmentTypes'; // Does not work for Window calls?

export const africaCountryCodes = ['BW', 'NA', 'ZM', 'ZW', 'ZA', 'RW', 'MZ', 'KE', 'MU', 'TZ', 'UG', 'LS', 'SC', 'SZ', 'MW', 'CG', 'MG'];

export const isRestOfWorld = countryCode => !africaCountryCodes.includes(countryCode);

export const isOnlyRestOfWorld = itinerary => {
  const accommodations = reduce(
    itinerary.itinerary.segments,
    (acc, segment) => {
      if (segment.type === 'stay' /*SEGMENT_TYPE.STAY*/) {
        const restOfWorld = segment.countryCode && isRestOfWorld(segment.countryCode);
        if (!restOfWorld) {
          acc.isOnlyROW = false;
        }
      }
      return acc;
    },
    { isOnlyROW: true },
  );
  return accommodations.isOnlyROW;
};
